import React from 'react';
import styles from './styles.module.scss';

import cn from 'classnames';

const ScrollBlock = ({ isBackground = true, maxHeight = 'auto', minHeight, id = '', ...props }) => (
  <div
    id={id !== '' ? id : null}
    className={cn(isBackground ? styles.scroll_block : styles.scroll_block_no_background, props.styles)}
    style={{ maxHeight, minHeight, ...props.style }}
  >
    {props.children}
  </div>
);

export default ScrollBlock;
